/**
 * 전역 스타일 (GlobalStyle)
 *
 * CSS 리셋, 기본 타이포그래피, 접근성, 스크롤바, 인쇄 스타일을 정의한다.
 */

import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* CSS 리셋 */
  *,
  *::before,
  *::after {
    font-family: ${({ theme }) => theme.fonts.pretendard};
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    /* scroll-behavior: smooth; */
  }

  body {
    min-height: 100vh;
    background-color: ${({ theme }) => theme.colors.bgWhite}; /* 테마에 따라 변경 */
    color: ${({ theme }) => theme.colors.fontBlackText}; /* 테마에 따라 변경 */
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.3s ease, color 0.3s ease; /* 부드러운 전환 */
  }

  /* 기본 스타일 제거 */
  ul,
  ol {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    color: inherit;
  }

  input,
  textarea,
  select {
    border: none;
    outline: none;
    background: none;
    font-family: inherit;
    color: inherit;
  }

  textarea {
    resize: vertical;
  }

  select {
    appearance: none;
  }

  img,
  picture,
  svg {
    max-width: 100%;
    height: auto;
    display: block;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }

  p {
    margin: 0;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }

  hr {
    border: none;
    height: 1px;
    background: ${({ theme }) => theme.colors.borderGray};
    margin: 0;
  }

  /* 포커스 스타일 */
  input:focus,
  textarea:focus,
  select:focus,
  button:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  /* 마우스 클릭 시 포커스 링 제거 (키보드 접근 시에만 표시) */
  input:focus:not(:focus-visible),
  textarea:focus:not(:focus-visible),
  select:focus:not(:focus-visible),
  button:focus:not(:focus-visible) {
    outline: none;
  }

  /* 접근성: 애니메이션 감소 선호 */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* 접근성: 고대비 모드 */
  @media (prefers-contrast: high) {
    body {
      background: white;
      color: black;
    }
  }

  /* 뮤직 플레이어 오디오 요소 */
  audio {
    width: 100%;
    height: auto;
  }

  /* 웹킷 커스텀 스크롤바 */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.bgGray[200]};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.fontGray[400]};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primary};
  }

  /* 텍스트 선택 스타일 */
  ::selection {
    background: ${({ theme }) => theme.colors.bgLightBlue};
    color: ${({ theme }) => theme.colors.primary};
  }

  /* 인쇄 스타일 */
  @media print {
    *,
    *::before,
    *::after {
      background: transparent !important;
      color: black !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }
  }
`;
